import { render } from "./Classic.vue?vue&type=template&id=628b2c06"
import script from "./Classic.vue?vue&type=script&lang=js"
export * from "./Classic.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__